import { render, staticRenderFns } from "./TrackContextMenu.vue?vue&type=template&id=481fc826&"
import script from "./TrackContextMenu.vue?vue&type=script&lang=ts&"
export * from "./TrackContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports